export default (params) => ({
  trigger: {
    name: 'coolblues_choice.select_all',
    params: params,
  },
  config: {
    schema: {
      index: {
        type: 'integer',
      },
      total_indices: {
        type: 'integer',
      },
      url: {
        type: 'string',
      },
      redirect: {
        type: 'string',
      },
    },
    event: {
      name: 'select_navigation',
      params: {
        sub_feature: 'coolblues_choice_overlay',
      },
    },
  },
});
